import { render, staticRenderFns } from "./PreOrderSku.vue?vue&type=template&id=15aa47b8&scoped=true&"
import script from "./PreOrderSku.vue?vue&type=script&lang=js&"
export * from "./PreOrderSku.vue?vue&type=script&lang=js&"
import style0 from "./PreOrderSku.vue?vue&type=style&index=0&id=15aa47b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aa47b8",
  null
  
)

export default component.exports